import * as THREE from "three";

/** Fits both formation depth and HP-label clearance; portrait views see the squads diagonally. */
export function fitBattleCamera(
  camera: THREE.PerspectiveCamera,
  target: THREE.Vector3,
  bounds: THREE.Box3,
): number {
  const outward = (
    camera.aspect < 0.85 ? new THREE.Vector3(1, 1.35, 0.35) : new THREE.Vector3(0, 1.85, 1.25)
  ).normalize();
  const right = new THREE.Vector3().crossVectors(new THREE.Vector3(0, 1, 0), outward).normalize();
  const up = new THREE.Vector3().crossVectors(outward, right).normalize();
  const tanY = Math.tan(THREE.MathUtils.degToRad(camera.fov / 2));
  const tanX = tanY * camera.aspect;
  let distance = 8;
  for (const x of [bounds.min.x, bounds.max.x])
    for (const y of [bounds.min.y, bounds.max.y])
      for (const z of [bounds.min.z, bounds.max.z]) {
        const point = new THREE.Vector3(x, y, z).sub(target),
          depth = point.dot(outward);
        distance = Math.max(
          distance,
          depth + Math.abs(point.dot(right)) / (tanX * 0.84),
          depth + Math.abs(point.dot(up)) / (tanY * 0.74),
        );
      }
  camera.position.copy(target).addScaledVector(outward, distance);
  camera.lookAt(target);
  camera.updateMatrixWorld(true);
  camera.updateProjectionMatrix();
  return distance;
}
